import React, { useEffect, useState } from 'react';

// Stylesheet import
import classes from './ShortsInteraction.module.css';

// Icon import from Feather icon
import { Clock as Time, Bookmark, MessageSquare as Discuss, Paperclip as Attachments, Share2, Send } from 'react-feather';


// useDispatch hook import
import { useDispatch, useSelector } from 'react-redux';

import API from "../../../Axios/axios.js";
import { apiErrorCodes } from "../../../apiErrorCodes.js";
import { useNavigate } from "react-router-dom";
// flutter web view context to detect when web is running on flutter webview
import { useFlutterWebView } from '../../../Context/FlutterWebView/FlutterWebViewContext.js';
import { Avatar } from '@mui/material';
import SuccessIcon from '../../CommonComponents/SuccessIcon/SuccessIcon.js';
import { addDiscussion } from '../../../Store/TVPagePostsSlice.js';


// boolean value to detect flutter webview
function ShortsDiscussionPanel({ postData, onClose }) {
    const isFlutterWebView = useFlutterWebView();
    // Destructuring postData props
    const {
        id,
        created_at,
        comment: { list_url, total, isOpenDiscussPanel, create_url },
        file_attachments_count
    } = postData;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const { userProfileData } = useSelector((state) => state.userProfileSlice);

    const [newCommentVal, setNewCommentVal] = useState('');
    const [isAcknowledgementActive, setIsAcknowledgementActive] = useState(false);


    // Handle Creator Profile Click
    const creatorNameClickHandler = (profileId) => {
        if (profileId === userProfileData.id) {
            navigate(`/userprofile`);
        } else {
            navigate(`/accounts/${profileId}/profile/`);
        }
    };

    // COMMENT
    // Change handler for discussion input
    const changeHandler = (event) => {
        setNewCommentVal(
            event.target.value.replace(/[^a-zA-Z0-9!#$%&'*+-/=?^_`{|@. ]/gm, '')
        );
    };
    const submitComment = async (event) => {
        event.preventDefault();
        // This will prevent the user from submitting the form if the entered value is empty or contains only space
        if (!newCommentVal || /^\s+$/.test(newCommentVal)) return;

        // this will change the sending button into success icon
        setIsAcknowledgementActive(true);

        // this will change the success icon into sending button again after 1 minute
        setTimeout(() => {
            setIsAcknowledgementActive(false);
        }, 1000);
        // Updating Data logic here
        setNewCommentVal('');

        // API call
        try {
            const response = await API.post(
                `${create_url}`,
                {
                    text: newCommentVal,
                },
                {
                    headers: { Authorization: `token ${localStorage.getItem('token')}` },
                }
            );
            if (response.data) {
                // This will add a new discussion on the TVPagePostSlice
                dispatch(addDiscussion(response.data));
            }
        } catch (e) {
            if (e.response.data.message === 'Invalid token.') {
                localStorage.removeItem('token');
            }
        }
    };
    return (<>

        <div className={classes.discussionPanel}>
            <div className={classes.discussionPanelHeader}>
                <h3 className={classes.discussionPanelTitle}>Comment(s) {total}</h3>
                <span className={classes.discussionPanelClose} onClick={() => onClose && onClose()}>&times;</span>
            </div>
            <hr />
            <div className={classes.discussionList}>
                {postData.comment.list.reverse().map(comment => (
                    <div className={classes.singleDiscussion}>

                        <div onClick={() => creatorNameClickHandler(comment.author_id, comment.urls.profile)} className={classes.creatorInfo}>
                            <Avatar
                                src={comment.profile_pic}
                                className={classes.creatorPic}

                                alt="Profile_pic"
                            />
                            <h2
                                className={classes.creatorName}
                            >
                                {comment.name}
                            </h2>
                        </div>
                        <span>{comment.discuss}</span>
                    </div>
                ))}
            </div>
            <div className={classes.addDiscussion}>
                <input type="text"
                    className={classes.discussInput}
                    placeholder="Discuss..."
                    onChange={changeHandler}
                    value={newCommentVal} />
                <button onClick={submitComment} className={classes.sendBtn}>
                    {isAcknowledgementActive
                        ? (<SuccessIcon checked={isAcknowledgementActive} />)
                        : (<Send className={classes.sendIcon} />)
                    }

                </button>
            </div>
        </div>

    </>);
}

export default ShortsDiscussionPanel;
